export const config = {
  title: 'KDS Cleaning Solutions LLC | Residential Cleaning in Dallas, TX',
  meta: {
    description:
      'KDS Cleaning Solutions LLC offers high-quality, eco-friendly residential cleaning services in Dallas, TX. Our professional team ensures a spotless and healthy home environment.',
    keywords: [
      'KDS Cleaning Solutions LLC',
      'Residential Cleaning Dallas',
      'Eco-Friendly Cleaning',
      'House Cleaning Services',
      'Move-In Cleaning',
      'Move-Out Cleaning',
      'Deep Cleaning Dallas',
      'Dallas Home Cleaning',
    ],
    author: 'KDS Cleaning Solutions LLC',
    canonicalUrl: 'https://kdscleaningsolutions.org/',
  },
  sections: {
    header: {
      businessName: 'KDS Cleaning Solutions LLC',
    },
    sectionB: {
      heroTitle: 'KDS Cleaning Solutions LLC',
      heroSubtitle: 'Your Trusted Partner for Quality Residential Cleaning in Dallas',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '4698497360',
      phoneLabel: '(469) 849-7360',
      heroBackgroundImage:         
      'https://media.istockphoto.com/id/1417833187/photo/professional-cleaner-vacuuming-a-carpet.jpg?s=612x612&w=0&k=20&c=5h8NBR190d46Ni4MclqJ7Zf9ZOtf3TM3gPRJaHUdMjk=',
      cardData: [
        {
          title: 'Quality Service',
          description:
            'Providing high-quality cleaning services to ensure a healthy and clean living space for our clients.',
        },
        {
          title: 'Reliable Professionals',
          description:
            'Our experienced team is dedicated to consistently meeting your cleaning needs.',
        },
        {
          title: 'Eco-Friendly Solutions',
          description:
            'We use environmentally friendly products and methods to promote a sustainable and healthy environment.',
        },
      ],
      description:
        'KDS Cleaning Solutions LLC offers a range of residential cleaning services, including basic cleaning, deep cleaning, move-in/move-out cleaning, and more. Our flexible scheduling options and transparent pricing ensure a hassle-free experience for our clients.',
    },
    sectionC: {
      servicesTitle: 'Our Cleaning Services',
      servicesDescription:
        'Explore our comprehensive range of cleaning services tailored to meet your specific needs.',
      cards: [
        {
          title: 'Basic Cleaning',
          description:
            'Regular cleaning services to maintain a tidy and comfortable home environment.',
            imageSrc: 'https://media.istockphoto.com/id/654153664/photo/cleaning-service-sponges-chemicals-and-mop.jpg?s=612x612&w=0&k=20&c=vHQzKbz7L8oEKEp5oQzfx8rwsOMAV3pHTV_1VPZsREA=',
            imageAlt: 'Basic Cleaning',
        },
        {
          title: 'Deep Cleaning',
          description:
            'Thorough cleaning services targeting every nook and cranny for a spotless home.',
            imageSrc: 'https://media.istockphoto.com/id/1316473356/photo/an-employee-pulls-a-trolley-for-cleaning-offices-woman-cleaner-is-engaged-in-work.jpg?s=612x612&w=0&k=20&c=6QWgeQ8HQU4TvT4lu9l2hBLiKUVYLcF_6-deEMn-vb8=',
            imageAlt: 'Deep Cleaning',
        },
        {
          title: 'Move-In/Out Cleaning',
          description:
            'Comprehensive cleaning services to prepare your home for moving in or out.',
            imageSrc: 'https://media.istockphoto.com/id/915613234/photo/young-woman-cleaning-wooden-floor-in-new-apartment.jpg?s=612x612&w=0&k=20&c=aKI_YY6YOjrvyhJDf6LSHvvTedx8mdsKyStcN5nMOb0=',
            imageAlt: 'Move-In/Out Cleaning',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Environmentally Friendly Cleaning',
        'One-Time, Weekly, Bi-Weekly, and Monthly Scheduling',
        'Transparent Pricing',
        'Add-On Services',
        'Exceptional Customer Service',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://jobber.s3.amazonaws.com/work_configuration_logos/1587658/original/1000009262.jpg?1739083618',
        alt: 'KDS Cleaning Solutions Team',
      },
      aboutText: [
        'KDS Cleaning Solutions LLC sets itself apart in the residential cleaning industry by prioritizing quality, reliability, and a deep understanding of the importance of cleaning in preventive healthcare.',
        'Our team of skilled professionals is committed to delivering exceptional service, using environmentally friendly products, offering flexible scheduling options, and ensuring transparent pricing. We recognize that every home is unique, and we strive to provide personalized cleaning solutions that cater to the specific needs of each client.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'KDS Cleaning Solutions Logo',
      businessName: 'KDS Cleaning Solutions LLC',
      contact: {
        phone: '4698497360',
        phoneLabel: '(469) 849-7360',
        email: 'kdscleaningsolutions@mail.com',
        website: 'https://kdscleaningsolutions.org/',
        address: 'Dallas, TX, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Dallas, TX, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d134290.258374681!2d-96.870474!3d32.820664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c19f77b4596d1%3A0x4a3f6c9b1c8a8e0!2sDallas%2C%20TX%2C%20USA!5e0!3m2!1sen!2sph!4v1712250000000!5m2!1sen!2sph',
    },
  },
};

export default config;
